@if (imageSrc(); as src) {
  <img class="item-photo" [class.item-photo-card]="size() === 'card'" [class.item-photo-face]="size() === 'face'" loading="lazy" decoding="async"
    [src]="src" [alt]="label()" [title]="label()">
} @else {
  <div class="item-photo item-photo-empty" [class.item-photo-card]="size() === 'card'" [class.item-photo-face]="size() === 'face'"></div>
}
